var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table_sort noselect_text",on:{"click":_vm.changeStatus}},[_c('span',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('div',{staticClass:"sort_icon"},[_c('i',{staticClass:"el-icon-caret-top",class:{active: _vm.status == 'asc'}}),_vm._v(" "),_c('i',{staticClass:"el-icon-caret-bottom",class:{active: _vm.status == 'desc'}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dde586c4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/components/TableSort.vue
// module id = null
// module chunks = 